import { useState } from "react";
import { BannerPromoCode } from "schemas/dashboard";

export const useCountDown = () => {
  const [display, setDisplay] = useState<string | null>(null);

  const createTimer = (
    bannerPromoCode: BannerPromoCode,
    newOverrideDate?: string,
  ) => {
    const timer = setInterval(() => {
      const nowLocal = new Date();
      const nowInPST = new Date(
        nowLocal.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }),
      );
      let overrideDate = bannerPromoCode?.dateEnding
        ? new Date(bannerPromoCode.dateEnding)
        : null;
      if (newOverrideDate) {
        overrideDate = new Date(newOverrideDate);
      }
      let countDownDate = null;
      if (overrideDate) {
        // Pad on extra day
        const overrideDateObj = new Date(overrideDate);
        overrideDateObj.setDate(overrideDateObj.getDate() + 1);
        // Convert override date to the END OF DAY PST (11:59 PM PST)
        const year = overrideDateObj.getUTCFullYear();
        const month = overrideDateObj.getUTCMonth();
        const day = overrideDateObj.getUTCDate();
        countDownDate = Date.UTC(year, month, day);
      }
      if (!countDownDate) {
        setDisplay("");
        clearInterval(timer);
        return;
      }
      const distance = countDownDate - nowInPST.getTime();
      // Time calculations
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let text = "";
      if (days > 0) {
        text += `${days}d `;
      }
      if (hours > 0) {
        text += `${hours}h `;
      }
      if (minutes > 0) {
        text += `${minutes}m `;
      }
      text += `${seconds}s`;
      setDisplay(text);

      // When countdown is over
      if (distance < 0) {
        clearInterval(timer);
        setDisplay("");
      }
    }, 1000);
  };

  return { display, createTimer };
};
